import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Loading } from '@topconagriculture/react-components';
import { useDashboardConfig } from '../../../hooks/useDashboardContext';
import { useVehicleQuery } from '../../../api/vehicle/useVehicleQuery';
const useStyles = makeStyles((theme) => ({
    statusWidgetContent: {
        padding: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        width: '100%',
        cursor: 'pointer',
    },
    textBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flext-start',
        width: '50%',
    },
    activeMachine: {
        width: '100%',
        borderRadius: '4px',
        boxShadow: `0 0 2px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 #2196F3`,
        marginBottom: '10px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '90px',
        maxHeight: '90px',
        '& > img': {
            marginRight: '10px',
        },
    },
    activeMachineNumber: {
        float: 'left',
        fontSize: 42,
        fontWeight: theme.font.weight.normal,
        marginRight: '10px',
    },
    activeMachineText: {
        float: 'right',
        lineHeight: '15px',
        paddingTop: '14px',
        width: '50%',
    },
    idleMachine: {
        width: 'calc(50% - 10px)',
        float: 'left',
        borderRadius: '4px',
        boxShadow: `0 0 2px 0 rgba(0,0,0,0.12), 0 0 3px 0 #46BC01`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '90px',
        maxHeight: '90px',
    },
    inactiveMachine: {
        width: '50%',
        float: 'right',
        borderRadius: '4px',
        boxShadow: `0 0 2px 0 rgba(0,0,0,0.12), 0 0 3px 0 #9B9B9B`,
        marginLeft: '10px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '90px',
        maxHeight: '90px',
    },
    smallNumber: {
        float: 'left',
        fontSize: '24px',
        fontWeight: 400,
        marginRight: '10px',
    },
    smallText: {
        float: 'right',
        fontSize: '10px',
        lineHeight: '10px',
        paddingTop: '7px',
        display: 'flex',
        alignItems: 'center',
        width: '50%',
    },
}));
const StatusWidget = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { data: status, isLoading } = useVehicleQuery();
    const { MACHINE_STATUS_VIEW_MORE_LINK, RESOURCES_BASE_URL } = useDashboardConfig();
    return (React.createElement(Loading, { isLoading: isLoading },
        React.createElement("div", { className: classes.statusWidgetContent, onClick: () => window.open(MACHINE_STATUS_VIEW_MORE_LINK, '_BLANK') },
            React.createElement("div", { className: classes.activeMachine },
                React.createElement("img", { src: `${RESOURCES_BASE_URL}/assets/images/dashboard/icons/status_active.svg`, alt: "Alert high" }),
                React.createElement("div", { className: classes.textBox },
                    React.createElement("div", { className: classes.activeMachineNumber }, (status || {}).ACTIVE),
                    React.createElement("div", { className: classes.activeMachineText }, t('widget:status:active')))),
            React.createElement("div", { className: classes.idleMachine },
                React.createElement("img", { src: `${RESOURCES_BASE_URL}/assets/images/dashboard/icons/status_idle.svg`, alt: "Alert medium" }),
                React.createElement("div", { className: classes.textBox },
                    React.createElement("div", { className: classes.smallNumber }, (status || {}).IDLE),
                    React.createElement("div", { className: classes.smallText }, t('widget:status:idle')))),
            React.createElement("div", { className: classes.inactiveMachine },
                React.createElement("img", { src: `${RESOURCES_BASE_URL}/assets/images/dashboard/icons/status_inactive.svg`, alt: "Alert low" }),
                React.createElement("div", { className: classes.textBox },
                    React.createElement("div", { className: classes.smallNumber }, (status || {}).INACTIVE),
                    React.createElement("div", { className: classes.smallText }, t('widget:status:inactive')))))));
};
export default StatusWidget;
//# sourceMappingURL=StatusWidget.js.map